import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {NgClass} from '@angular/common';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {IconDefinition} from '@fortawesome/fontawesome-svg-core';
import {classifyStatusValue} from './status-classify';
import {BicDropdownElementComponent, BicSelectComponent} from '@buildinginformationcloud/bic-ui-components';
import {JsonSchema} from '../schema-form.types';
import {enumLabel} from '../widget-registry';

interface StatusOption {
  value: any;
  label: string;
  icon: IconDefinition;
  colorClass: string;
}

/**
 * x-widget:status → enum dropdown where each option carries a semantic status icon.
 * The icon/color is derived generically from the value (success / error / warning /
 * neutral), so any enum works without per-module wiring.
 */
@Component({
  selector: 'sf-status',
  standalone: true,
  imports: [BicSelectComponent, BicDropdownElementComponent, FaIconComponent, NgClass],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <bic-select
      [value]="value"
      [placeholder]="placeholder"
      (valueChange)="valueChange.emit($event)">
      @for (opt of options; track opt.value) {
        <bic-dropdown-element [value]="opt.value">
          <fa-icon iconLeft [icon]="opt.icon" [ngClass]="opt.colorClass"></fa-icon>
          {{ opt.label }}
        </bic-dropdown-element>
      }
    </bic-select>
  `,
})
export class SfStatusComponent implements OnInit {
  @Input() schema: JsonSchema | null = null;
  @Input() value: any;
  @Output() valueChange = new EventEmitter<any>();

  options: StatusOption[] = [];

  get placeholder(): string {
    return this.schema?.['x-placeholder'] ?? 'Status wählen…';
  }

  ngOnInit(): void {
    const values = this.schema?.enum ?? [];
    this.options = values.map(v => ({value: v, label: enumLabel(this.schema, v), ...classifyStatusValue(v)}));
  }
}
